var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowDown = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35996 4.88137C4.20634 6.53899 6.28842 7.87286 7.70267 10.0485C8.42288 11.1363 9.02524 11.2788 10.0074 10.5406C10.3216 10.3075 10.649 10.0614 10.8847 9.75064C12.1942 8.01531 13.8441 6.75914 15.4417 5.39937C16.2405 4.72596 16.856 3.9101 17 2.75754C16.5679 0.983362 16.1619 0.81501 15.0358 2.07118C14.0275 3.18489 12.8097 4.0137 11.7359 5.03677C9.53594 7.14765 9.58832 7.09585 7.40148 4.98497C5.72534 3.3662 4.16706 1.56612 2.20283 0.348802C1.54809 -0.0526532 0.985006 -0.195105 0.421928 0.400603C-0.101866 0.944511 -0.154244 2.04528 0.356455 2.74459C0.958816 3.5475 1.63975 4.24681 2.35996 4.88137Z",
    fill: "#14AA40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35996 14.8814C4.20634 16.539 6.28842 17.8729 7.70267 20.0485C8.42288 21.1363 9.02524 21.2788 10.0074 20.5406C10.3216 20.3075 10.649 20.0614 10.8847 19.7506C12.1942 18.0153 13.8441 16.7591 15.4417 15.3994C16.2405 14.726 16.856 13.9101 17 12.7575C16.5679 10.9834 16.1619 10.815 15.0358 12.0712C14.0275 13.1849 12.8097 14.0137 11.7359 15.0368C9.53594 17.1476 9.58832 17.0958 7.40148 14.985C5.72534 13.3662 4.16706 11.5661 2.20283 10.3488C1.54809 9.94735 0.985006 9.80489 0.421928 10.4006C-0.101866 10.9445 -0.154244 12.0453 0.356455 12.7446C0.958816 13.5475 1.63975 14.2468 2.35996 14.8814Z",
    fill: "#14AA40"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-down.29b02aee.svg";
export { ForwardRef as ReactComponent };